import _ from 'lodash';
import React, {Component } from 'react';
import PropTypes from 'prop-types';
//import moment from 'moment-timezone';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { getGlobalClasses } from '../../themes';

//containers
import AuthUserContainer from '../../containers/AuthUser';
import TicketContainer from '../../containers/Ticket/Ticket';

//- UI / Form
import SectionHeader from "../../components/SectionHeader";

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		emailBody : {
			border : '1px solid #ddd',
		},
	};
};

const idField = 'ticketId';
//const itemDisplay = 'Ticket';

class EmailDisplay extends Component {
	constructor(props) {
		super(props);

		const action = _.get(this.props, 'match.params.action');
		const id = parseInt(_.get(this.props, `match.params.${idField}`), 10);

		this.state = {
			[idField] : id,
			action,

			formHasBeenFilled : false,
			ticketCategoryId : '',
			ticketSchema : undefined,

			formFieldError: {},
		};
	}

	componentDidMount () {

		const {
			getTicketEmailInfo,
			showErrors,
		} = this.props;

		const { action, ticketId } = this.state;

		getTicketEmailInfo({
			params : {
				ticketId,
				action,
			},
			callback : (err, r) => {
				if (err) {
					return showErrors([err]);
				}
				if (!r) {
					return showErrors(['No result from getEmailInfo']);
				}

				const { subject, html, to, assignedToUser } = r;
				if (!subject || !html) {
					return showErrors(['Missing subject or body']);
				}

				this.setState({ subject, html, to, assignedToUser });
			}
		});
	}

	render () {
		const {
			classes,
		} = this.props;

		const {
			subject,
			html,
			//action,
		} = this.state;


		return (<Paper className={classes.globalMainPaper} style={{minHeight : 600}}>
			<SectionHeader label={"Email Subject"} />
			<div>
				{subject}
			</div>

			<SectionHeader label={"Email Body"} />
			<div className={classes.emailBody}>
				<div dangerouslySetInnerHTML={{__html : html }} />
			</div>
		</Paper>);
	}
}

EmailDisplay.propTypes = {
	getTicketEmailInfo : PropTypes.func.isRequired,

	showErrors : PropTypes.func.isRequired,
	authUser : PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
	TicketContainer,
])(EmailDisplay);
